export default __webpack_public_path__ + "static/media/ic_back_arrow.1c8b1928.svg";